import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  CREATE_ALLOCATION: 'CREATE_ALLOCATION',
  SIGN_ALLOCATION: 'SIGN_ALLOCATION',
  CONFIRM_ALLOCATION: 'CONFIRM_ALLOCATION',
  FETCH_ALLOCATIONS: 'FETCH_ALLOCATIONS',
  FETCH_INSTALLMENTS: 'FETCH_INSTALLMENTS',
  //DISPOSALS
  FETCH_DISPOSALS: 'FETCH_DISPOSALS',
};

export default {
  createAllocation: allocationData => {
    return apiClient.post('/allocation', allocationData, {
      apiCallId: apiCallIds.CREATE_ALLOCATION,
    });
  },

  signAllocation: allocationId => {
    return apiClient.post(`/allocation/${allocationId}/sign`, undefined, {
      apiCallId: apiCallIds.SIGN_ALLOCATION,
    });
  },

  confirmAllocation: (allocationId, token) => {
    return apiClient.post(
      `/allocation/${allocationId}/confirm`,
      { token },
      { apiCallId: apiCallIds.CONFIRM_ALLOCATION }
    );
  },

  resendSmsCodeAllocation: allocationId => {
    return apiClient.get(`/allocation/${allocationId}/resendSmsCode`);
  },

  fetchAllocations: options => {
    return apiClient.get(`/allocation?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ALLOCATIONS,
    });
  },

  deleteAllocation: allocationId => {
    return apiClient.delete(`/allocation/${allocationId}`);
  },

  fetchInstallments: allocationId => {
    return apiClient.get(`/allocation/${allocationId}/installments`, {
      apiCallId: apiCallIds.FETCH_INSTALLMENTS,
    });
  },
//DISPOSALS
  fetchDisposals: options => {
    return apiClient.get(`/disposals?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_DISPOSALS,
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/allocations/api/index.js